export default {
  FETCH_ALL_USER_INVOICES_SUCCESS: 'FETCH_ALL_USER_INVOICES_SUCCESS',
  FETCH_ALL_USER_INVOICES_FAILED: 'FETCH_ALL_USER_INVOICES_FAILED',
  FETCH_ALL_USER_INVOICES_REJECT: 'FETCH_ALL_USER_INVOICES_REJECT',
  FETCH_ALL_USER_INVOICES_LOADING: 'FETCH_ALL_USER_INVOICES_LOADING',

  TEMPORARY_SAVE_INVOICE_LOADING: 'TEMPORARY_SAVE_INVOICE_LOADING',
  TEMPORARY_SAVE_INVOICE_REJECT: 'TEMPORARY_SAVE_INVOICE_REJECT',
  TEMPORARY_SAVE_INVOICE_FAILED: 'TEMPORARY_SAVE_INVOICE_FAILED',
  TEMPORARY_SAVE_INVOICE_SUCCESS: 'TEMPORARY_SAVE_INVOICE_SUCCESS',

  FINAL_SAVE_INVOICE_LOADING: 'FINAL_SAVE_INVOICE_LOADING',
  FINAL_SAVE_INVOICE_REJECT: 'FINAL_SAVE_INVOICE_REJECT',
  FINAL_SAVE_INVOICE_FAILED: 'FINAL_SAVE_INVOICE_FAILED',
  FINAL_SAVE_INVOICE_SUCCESS: 'FINAL_SAVE_INVOICE_SUCCESS'
};
